import { render, staticRenderFns } from "./RowBase.vue?vue&type=template&id=1bae827c&scoped=true"
import script from "./RowBase.vue?vue&type=script&lang=js"
export * from "./RowBase.vue?vue&type=script&lang=js"
import style0 from "./RowBase.vue?vue&type=style&index=0&id=1bae827c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bae827c",
  null
  
)

export default component.exports